export default __webpack_public_path__ + "static/media/mercedes_benz.f11b756f.webp";